import React, { useContext, useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table';

import { SocketContext } from '../context/SocketContext'

export const TablaTicketsPendientes = ( { usuario, dataFromTable } ) => {
    
    const { socket } = useContext( SocketContext );
    const [pendientesLista, setPendientesLista] = useState([]);
    
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [sortedBy, setSortedBy] = useState('hora');
    const [sortDirection, setSortDirection] = useState('asc');

    const datos={
        entidad: usuario.entidad,
        uidUsuario: usuario.uidUsuario,
        search : searchTerm || '',
        itemsPerPage: itemsPerPage || '',
        sortedBy: sortedBy,
        sortDirection: sortDirection,
       
    }

    const handleSort = async (header) => {
        // console.log(header)    
        setSortedBy(header);
        const direction= sortDirection === 'asc' ? 'desc' : 'asc'
        setSortDirection( direction );
        datos.sortedBy= header;
        datos.sortDirection= direction;

        // setIsLoading(true)
        socket.emit( 'tickets-pendientes-lista', datos, async ( lista ) => {
            const asigndos= localStorage.getItem('tiposAtencion').split(",");
            const filteredArray = lista.filter(item => asigndos.indexOf(item.uidTipoAtencion) >= 0);
            setPendientesLista(filteredArray);
        })
    }

    const handleSearch = (ev) => {
        setSearchTerm(ev.target.value);
        
    };
    

    useEffect(() => {
    
        socket.on('tickets-pendientes-lista', ( pend )=> {
            console.log("si estoy ")
            const asigndos= localStorage.getItem('tiposAtencion').split(",");
            const filteredArray = pend.filter(item => asigndos.indexOf(item.uidTipoAtencion) >= 0);
            setPendientesLista(filteredArray);
            

        })

        return () => {
            socket.off('tickets-pendientes-lista')
        }
    })

    useEffect(() => {
        getTiposAtencion();
    
    }, [socket])

    
    useEffect(() => {
    
        socket.emit('tickets-pendientes-lista', datos, ( pend )=> {

            const asigndos= localStorage.getItem('tiposAtencion') ? localStorage.getItem('tiposAtencion').split(",") : [];
            const filteredArray = pend.filter(item => asigndos.indexOf(item.uidTipoAtencion) >= 0);
            setPendientesLista(filteredArray);
            

        })

        return () => {
            socket.off('tickets-pendientes-lista')
        }
    }, [searchTerm, currentPage, itemsPerPage])

    useEffect(() => {
        getTiposAtencion();
    
    }, [socket])

    const getTiposAtencion = () => {

        datos.pantalla='tablaTickets';
        socket.emit('tickets-pendientes-lista', datos, ( pend )=> {

            const tiposAtencion = localStorage.getItem('tiposAtencion');
            if( tiposAtencion === null ) {
                setPendientesLista( [] );
            }else{
                const asigndos= localStorage.getItem('tiposAtencion').split(",");
                const filteredArray = pend.filter(item => asigndos.indexOf(item.uidTipoAtencion) >= 0);
                setPendientesLista(filteredArray);

            }

            return () => {
                socket.off('tickets-pendientes-lista')
            }
            

        })

    } 

    const llamarPorTicket = (ev, uidTicket) => {
        ev.preventDefault();
        
        datos.uidTicket= uidTicket;
        datos.uidModulo= usuario.uidModulo;
        datos.agente= usuario.agente;
        datos.modulo= usuario.modulo;

        const ultimoTicket= document.getElementById('ticketAnterior');
        const ticketAnterior= (ultimoTicket) ? ultimoTicket.value : '';
        datos.ticketAnterior= ticketAnterior;

        socket.emit('llamar-por-ticket', { datos }, ( ticket )=> {
            
            dataFromTable( ticket )
            console.log(ticket)
            // // actualizamos los tipos de atencion asignados
            // const asigndos= localStorage.getItem('tiposAtencion').split(",");
            // const filteredArray = pend.filter(item => asigndos.indexOf(item.uidTipoAtencion) >= 0);
            // setPendientesLista(filteredArray);
            

        })
    }

    return (
        <div className='form-group col-lg-6 col-12 rounded shadow'>

            <div className='col-12'>
                <div className=' float-end col-lg-4 col-12'>

                    <input
                        type='text'
                        placeholder='Buscar...'
                        className='form-control'
                        defaultValue={searchTerm}
                        onChange={ (ev) => handleSearch(ev)}
                    />

                </div>
            
            </div>

            <div className='col-12 ' style={{ fontSize: '14px', verticalAlign: 'middle' }} >
                <Table responsive="md" striped hover style={{minWidth: 600}} className='max400' >
                    <thead>
                        <tr>
                            <th width={'10%'}>Ticket</th>
                            <th width={'35%'} onClick={ () => handleSort('tipoAtencion') }>
                                <span style={{ color: "gray" }}>
                                    <a href='/#' onClick={ ev => ev.preventDefault() } > Atención </a>
                                    {sortedBy === 'tipoAtencion' && sortDirection === 'asc' && '▲'}
                                    {sortedBy === 'tipoAtencion' && sortDirection === 'desc' && '▼'}
                                </span> 
                            </th>
                            <th width={'35%'} onClick={ () => handleSort('nombrePaciente') }>
                                <span style={{ color: "gray" }}>
                                    <a href='/#' onClick={ ev => ev.preventDefault() } > Paciente </a>
                                    {sortedBy === 'nombrePaciente' && sortDirection === 'asc' && '▲'}
                                    {sortedBy === 'nombrePaciente' && sortDirection === 'desc' && '▼'}
                                </span> 
                            </th>
                            <th width={'20%'} onClick={ () => handleSort('hora') }>
                                <a href='/#' onClick={ ev => ev.preventDefault() } > Hora </a>

                                <span style={{ color: "gray" }}>
                                    {sortedBy === 'hora' && sortDirection === 'asc' && '▲'}
                                    {sortedBy === 'hora' && sortDirection === 'desc' && '▼'}
                                </span> 
                            </th>
                        </tr>

                    </thead>
                    <tbody width={'100%'} style={{ fontSize: '10px', verticalAlign: 'middle' }} >
                        {pendientesLista.map((item, i) => (

                            <tr key={item.uidTicket}  >
                                    <td width={'10%'} className='p-0' >
                                        <button className='btn btn-sm btn-link' onClick={(ev) => llamarPorTicket(ev, item.uidTicket)}>
                                            { item.codigoTipoAtencion.toUpperCase() }-{ item.numeroTicket }
                                        </button>
                                    </td>
                                    <td width={'35%'} className='p-0'> 
                                        {item.tipoAtencion.toUpperCase()}
                                    </td>

                                    <td width={'35%'} className='p-0'> 
                                        { item.nombrePaciente.trim() === '' ? item.numeroDocumento : item.nombrePaciente.toUpperCase()}
                                    </td>

                                    <td width={'20%'} className='p-0'> 
                                        { item.hora }
                                    </td>

                            
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>



        </div>
    )
}
